import React, { useMemo } from 'react';
import { getBinMoistureDisplayRows } from '../utils/designMixMoistureUtils';

function DesignMixAggregateBins({ plantConfig = {}, moistureRecord, inputs = {}, onChange }) {
  const binRows = useMemo(
    () => getBinMoistureDisplayRows(plantConfig, moistureRecord, inputs),
    [plantConfig, moistureRecord, inputs],
  );

  return (
    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel design-mix-recipe-card">
      <h5 className="col-sm-11"><b>AGGREGATE BINS</b></h5>

      <div className="form-row col-sm-12 design-mix-bin-header small font-weight-bold text-muted mb-1">
        <span className="col-sm-2">Bin</span>
        <span className="col-sm-2 text-right">Target</span>
        <span className="col-sm-2 text-right">Moisture %</span>
        <span className="col-sm-2 text-right">Absorption %</span>
        <span className="col-sm-2 text-right">Target (Corrected)</span>
        <span className="col-sm-2 text-center">Material</span>
      </div>

      {binRows.map((bin) => (
        <React.Fragment key={bin.aggKey}>
          <label htmlFor={`bin_${bin.index}`} className="form-group col-sm-2 text-right">
            Bin {bin.index}
          </label>
          <input
            type="number"
            id={`bin_${bin.index}`}
            size="10"
            className="form-control col-sm-2 totalval"
            disabled={!bin.enabled}
            style={{ cursor: bin.enabled ? 'auto' : 'not-allowed' }}
            name={bin.aggKey}
            onChange={onChange}
            value={inputs[bin.aggKey] ?? 0}
            min="0"
          />
          <input
            type="number"
            className="form-control col-sm-2 design-mix-readonly-field"
            value={bin.enabled ? bin.moisture : ''}
            readOnly
            disabled
            tabIndex={-1}
            title="Moisture % from plant moisture correction"
          />
          <input
            type="number"
            className="form-control col-sm-2 design-mix-readonly-field"
            value={bin.enabled ? bin.absorption : ''}
            readOnly
            disabled
            tabIndex={-1}
            title="Absorption % from plant moisture correction"
          />
          <input
            type="number"
            className="form-control col-sm-2 design-mix-readonly-field"
            value={bin.enabled ? bin.correctedTarget : ''}
            readOnly
            disabled
            tabIndex={-1}
            title="Target after moisture correction"
          />
          <strong className="form-group col-sm-2 text-center text-danger">
            {bin.enabled ? bin.label : null}
          </strong>
          <br />
        </React.Fragment>
      ))}
    </div>
  );
}

export default DesignMixAggregateBins;
